import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button, Modal, Form,Spinner } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/contact`;

function ContactDetails({ instanceId }) {
  const location = useLocation();
  const [contacts, setContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [errors, setErrors] = useState({});
  const WithDeletePermission = withPermission(({ children }) => children, ['contact-delete']);
  const WithEditPermission = withPermission(({ children }) => children, ['contact-edit']);
  const WithCreatePermission = withPermission(({ children }) => children, ['contact-create']);
  const [searchQuery, setSearchQuery] = useState('');
  const debounceTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false); // Track loading state

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    contact_id: instanceId,
    type: '',
    position: '',
    contact_type:null,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  // Ref to track whether the API call has been made
  const didFetchRef = useRef(false);

  const determineType = () => {
    if (location.pathname.includes('/instance/')) {
      return 'instance';
    } else if (location.pathname.includes('/tenant/')) {
      return 'tenant';
    }
    else if (location.pathname.includes('/client/')) {
      return 'client';
    }
    else if (location.pathname.includes('/project/')) {
      return 'project';
    }
    return '';
  };

//   useEffect(() => {
//     if (!didFetchRef.current) {
//       const currentType = determineType();
//       setFormData((prev) => ({ ...prev, type: currentType, contact_id: instanceId }));
//       fetchContacts(currentType);
//       didFetchRef.current = true;  // Mark the fetch as done
//     }
//   }, [instanceId, location.pathname]); // Dependencies are instanceId and pathname
//   useEffect(() => {
//     if (debounceTimeoutRef.current) {
//         clearTimeout(debounceTimeoutRef.current);
//     }

//     debounceTimeoutRef.current = setTimeout(() => {
//         fetchContacts(1, searchQuery);
//     }, searchQuery ? 1500 : 0); 

//     return () => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }
//     };
// }, [searchQuery]);
useEffect(() => {
  const fetchContactsHandler = async () => {
      const currentType = determineType();
      setFormData((prev) => ({ ...prev, type: currentType, contact_id: instanceId }));

      if (searchQuery) {
          // If search query exists, perform search
          fetchContacts(currentType,1, searchQuery);
      } else {
          // If no search query, fetch contacts without search filter
          fetchContacts(currentType,1);
      }
  };

  // Debounce search query if available
  if (searchQuery) {
      if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
      }

      debounceTimeoutRef.current = setTimeout(() => {
          fetchContactsHandler();
      }, 1500); // Debounce timeout

  } else {
      // No search query, immediately fetch contacts
      fetchContactsHandler();
  }

  return () => {
      if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
      }
  };
}, [instanceId, location.pathname, searchQuery]); // Watch instanceId, pathname, and searchQuery

const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);

};
  const fetchContacts = async (type, page = 1) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');

      const token = userInfo?.token;
      const response = await axios.get(`${API_URL}?contact_id=${instanceId}&type=${type}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,

        },
        params: {
          page: page,
          search: searchQuery,
        },  
      });
      setContacts(response.data.Data);
      setPageCount(response.data.last_page);

    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  const handleAddContact = () => {
    setFormData({ name: '', email: '', phone: '', position: '', contact_id: instanceId, type: determineType() });
    setIsEdit(false);
    setSelectedContact(null);
    setShowModal(true);
    setErrors({});

  };

  const handleEditContact = (contact) => {
    setFormData(contact);
    setIsEdit(true);
    setSelectedContact(contact);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setErrors({}); // Clear any residual error
  };
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
  }).then(async (result) => {
      if (result.isConfirmed) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');

        const token = userInfo?.token;
        await axios.delete(`${API_URL}/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Tenant-Origin': origin,

          },
        });
        setContacts(contacts.filter(contact => contact.id !== id));
        Swal.fire(
          "Deleted!",
          "The contact has been deleted.",
          "success"
      );
  } catch (error) {
      console.error('Error deleting contact:', error);
      Swal.fire(
          "Error!",
          "Failed to delete contact. Please try again.",
          "error"
      );
  }
}
});

    
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => {
      const { [name]: removed, ...rest } = prevErrors; // Remove the key
      return rest;
    });
  };

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
    fetchContacts(determineType(), newPage);
  };
  useEffect(() => {
    if (!showModal) {
        setErrors({});
    }
}, [showModal]);

const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.phone) newErrors.phone = 'Phone is required';

  
    
    return newErrors;
  };
  const handleSubmit = async () => {
    setLoading(true); 
    const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
    try {
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');

      const token = userInfo?.token;
      if (isEdit) {
        const response = await axios.put(`${API_URL}/${selectedContact.id}`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Tenant-Origin': origin,

          },
        });
        setContacts(contacts.map(contact => (contact.id === selectedContact.id ? response.data.contact : contact)));
      } else {
        const response = await axios.post(API_URL, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Tenant-Origin': origin,

          },
        });
        setContacts([...contacts, response.data.contact]);
      }
      setErrors({});

      setShowModal(false);
    } catch (error) {
      
        console.error("Unexpected error: ", error);
          }
    finally {
      setLoading(false); 
    }
  };

  return (
    <div>
      <h4>Contacts</h4>
      <div className="d-flex justify-content-end mb-2">
                {/* Search Box */}
                <div className="search-box me-2">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <i className="bx bx-search-alt search-icon" />
                    </div>
                </div>
       <WithCreatePermission><Button onClick={handleAddContact} className="d-flex float-end mb-3 btn btn-secondary btn-rounded waves-effect waves-light me-2" // float-end to push button to the right
      >Add Contact</Button></WithCreatePermission></div>
      <table id="datatable" className="table table-bordered dt-responsive nowrap w-100">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Position</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => (
            <tr key={contact.id}>
              <td>{contact.name}</td>
              <td>{contact.email}</td>
              <td>{contact.phone}</td>
              <td>{contact.position}</td>

              <td>
                <div className="dropdown">
                  <i
                    className="mdi mdi-dots-horizontal font-size-18"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ cursor: 'pointer' }}
                  ></i>
                  <ul className="dropdown-menu dropdown-menu-end font-size-14">
                    <li><WithEditPermission>
                      <button className="dropdown-item" onClick={() => handleEditContact(contact)}>
                        Edit
                      </button></WithEditPermission>
                    </li>
                    <li><WithDeletePermission>
                      <button className="dropdown-item" onClick={() => handleDelete(contact.id)}>
                        Delete
                      </button></WithDeletePermission>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-end pagination-sm">
      <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageChange}
                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item previous'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item next'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            activeClassName={'active'}
                        />
      </div>
      {/* Modal for Add/Edit Contact */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Contact' : 'Add Contact'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="contactName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" name="name" value={formData.name}
                onChange={handleInputChange}
                className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

              />
              {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

            </Form.Group>
            <Form.Group controlId="contactEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={formData.email}
                className={`form-control ${errors?.email ? 'is-invalid' : ''}`}

                onChange={handleInputChange} />
                             {errors.email && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.email}</div>}

            </Form.Group>
            <Form.Group controlId="contactPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control type="text" name="phone" value={formData.phone}
                className={`form-control ${errors?.phone ? 'is-invalid' : ''}`}

                onChange={handleInputChange} />
                              {errors.phone && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.phone}</div>}

            </Form.Group>
            <Form.Group controlId="contactPosition">
              <Form.Label>Position</Form.Label>
              <Form.Control type="text" name="position" value={formData.position} onChange={handleInputChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={handleSubmit}  disabled={loading} // Disable the button during loading
                                            >
                                               
                                                {loading && (
                                                    <>
                                                        <Spinner
                                                            animation="border"
                                                            size="sm"
                                                            style={{ marginRight: '10px' }} // Spacing between the spinner and text
                                                        />
                                                    </>
                                                )}Save Contact</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ContactDetails;


